// Modules
import React from 'react'

// Routes
import Routes from './routes/Main'

// Components
import Page from 'components/layout/page/Page'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'

// Styles
import './Error.scss'

// Page: Error
function Error () {
	// Data
	// const { translate } = useLanguage('pages.error')

	// Render
	return (
		<Page name="error">
			<Routes />
		</Page>
	)
}

// Export
export default Error
